import { FilterDataList } from "../../../../types/Filter";

export function normalizeHistoryFilterData(data: FilterDataList): FilterDataList {
  const { phone1, followUp, withoutTax, withoutTotal, ...filters } = data;

  // Older History presets used the client-list field name instead of the quote API's name.
  const phone =
    typeof filters.phone === "object" && filters.phone.value
      ? filters.phone
      : phone1 || filters.phone;

  if (phone !== undefined) {
    filters.phone =
      typeof phone === "object"
        ? {
            ...phone,
            select: phone.select === "it's start" ? "it`s start" : phone.select,
          }
        : phone;
  }

  return filters;
}
